// src/app/core/guards/analytics.guard.ts

import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { PermissionService } from '@core/services/permission.service';
import { guardWithProfile } from './guard.utils';

/** Gates /analytics — requires either policy or claim analytics permission. */
export const analyticsGuard: CanMatchFn = () => {
  const perm = inject(PermissionService);
  return guardWithProfile(() => perm.canViewAnyAnalytics(), '/dashboard');
};
